import React from 'react';
import { Save } from 'lucide-react';
import { Button } from '../../../catalyst/button';
import DESIGN from '../designSystem';

const PlanDetailsForm = ({ 
  planForm, 
  setPlanForm, 
  isEditing, 
  onSave, 
  onCancel,
  selectedPlan 
}) => {
  return (
    <div className="bg-white shadow rounded-lg mb-4">
      <div className={DESIGN.header.padding + ' ' + DESIGN.header.borderBottom}>
        <h3 className={DESIGN.header.title}>Plan Details</h3>
      </div>
      <div className={DESIGN.body.padding + ' space-y-3'}>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Plan Name</label>
          <input
            type="text"
            value={planForm.name}
            onChange={(e) => setPlanForm({...planForm, name: e.target.value})}
            disabled={!isEditing}
            className="w-full px-3 py-2 border border-gray-300 rounded-md disabled:bg-gray-50"
            placeholder="e.g., Portsmouth to Cowes"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Vessel Speed (knots)</label>
          <input
            type="number"
            value={planForm.vesselSpeed}
            onChange={(e) => setPlanForm({...planForm, vesselSpeed: parseFloat(e.target.value)})}
            disabled={!isEditing}
            className="w-full px-3 py-2 border border-gray-300 rounded-md disabled:bg-gray-50"
            step="0.1"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Notes</label>
          <textarea
            value={planForm.notes}
            onChange={(e) => setPlanForm({...planForm, notes: e.target.value})}
            disabled={!isEditing}
            className="w-full px-3 py-2 border border-gray-300 rounded-md disabled:bg-gray-50"
            rows={3}
            placeholder="Weather considerations, hazards, etc."
          />
        </div>
        {isEditing && (
          <div className="pt-4 border-t border-gray-200 flex gap-2">
            <Button color="indigo" className="flex-1" onClick={onSave}>
              <Save className="h-4 w-4 mr-2" />
              Save
            </Button>
            <Button
              color="white"
              className="flex-1"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlanDetailsForm;